module.exports = __webpack_public_path__ + "img/yellow_heart.674e0831.png";